import { render, staticRenderFns } from "./ClickAndBuyNameForm.vue?vue&type=template&id=2ad6652a&scoped=true"
import script from "./ClickAndBuyNameForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6652a",
  null
  
)

export default component.exports